let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lx3pt")).then(() => parcelRequire('avmB1'));